import { useContext } from 'react';
import { Heading } from '../../../../components/heading';
import { ProductScreenContext } from '../../contexts/product-screen-context';
import { StyledHeaderTitle } from './styled';

interface HeaderTitleProps {
  position: 'left' | 'center' | 'right';
  name?: string;
}

export function HeaderTitle({ position, name }: HeaderTitleProps): JSX.Element {
  const context = useContext(ProductScreenContext);
  return (
    <StyledHeaderTitle position={position}>
      <Heading variant="h3">
        {name || context?.productScreen.screen.name}
      </Heading>
    </StyledHeaderTitle>
  );
}
